import React, { Component } from 'react';
import CountdownTimer from './CountdownTimer';
import { Utils } from '../../utils/Utils';

/**
 * cid=2_12_5&page=26  一个选项
 */

// 互斥的元素在 chooseRightWordList 中的索引值（需要从已选择的列表中移出去）
let willRemoveIndex;
// 当前选择的元素在 this.opsWords 中的索引值
let selectOpsWordsIndex;
// 互斥的元素在 this.opsWords 中的索引值
let mutexOpsWordsIndex;

window.actionID;

class ChooseWords extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: props.item,
            selected: false,
            currStarCount: 0,   //当前的星星数
            currSubjectCount: 0,    //当前题目数（有starSubject=1的时候就加1）
            // 纠错时已选择的单词
            chooseWrongWordList: [],
            // 选择填空时选择的单词
            chooseRightWordList: [],
        }
        this.cid = Utils.getHashQueryString("cid");
        this.putaoid = Utils.getCookie('putaoid') || 0;
        this.token = Utils.getCookie('token');
        this.sentence = props.item && props.item.detail && props.item.detail.sentence ? props.item.detail.sentence.split(' ') : [];
        this.actionType = props.item.actionType;
        // 纠错或者选择的个数
        this.chooseWordNum = props.item && props.item.detail && ((props.item.detail.wrongWordIndex && props.item.detail.wrongWordIndex.length) || (props.item.detail.opsWords && props.item.detail.opsWords.length));
        // 选择题，可选择的单词
        this.opsWords = [];
        // 选择题，正确的单词
        this.rightWords = [];
        this.roundNum = 1;  // 第几轮
        this.startWorkTime = new Date().getTime();  // 开始时间，用来计算完成这个模板使用的时间，用于算给积分

        if (props.item && props.item.detail && props.item.detail.opsWords && Array.isArray(props.item.detail.opsWords)) {
            var tempOpsWords = props.item.detail.opsWords;
            for (let i = 0; i < tempOpsWords.length; i++) {
                if (tempOpsWords[i].rightIndex !== null || tempOpsWords[i].rightIndex !== undefined) {
                    this.rightWords.push(tempOpsWords[i].rightIndex);
                }

                if (tempOpsWords[i].optionsIndex && Array.isArray(tempOpsWords[i].optionsIndex)) {
                    this.opsWords.push.apply(this.opsWords, tempOpsWords[i].optionsIndex);
                }
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            currStarCount: nextProps.currStarCount,
            currSubjectCount: nextProps.currSubjectCount,
        })
    }

    componentWillMount() {
        let sentenceElements = document.getElementById('choose-sentent');

        if (sentenceElements) {
            sentenceElements.parentNode.removeChild(sentenceElements);
        }
    }

    componentDidMount() {
        this.startWorkTime = new Date().getTime();
    }

    chooseWordsHandler(e) {
        if (this.actionType === "ShowTextArea_" || this.actionType === "TeacherTest_") {
            return;
        } else if (this.actionType === "ChooseWrongWordsInteraction_") {
            this.wrongWordsHandler(e);
        } else if (this.actionType === "ChooseRightWordsInteraction_") {
            this.trueWordsHandler(e);
        }
    }

    // 纠错
    wrongWordsHandler(e) {
        const { chooseWrongWordList, selected } = this.state;
        if (!selected) {
            let id = parseInt(e.target.id, 10);
            if (e.target.style.background) {     // 从已选择的数组中删除
                e.target.style.background = "";
                let index = chooseWrongWordList.indexOf(id);
                if (index > -1) {
                    chooseWrongWordList.splice(index, 1);
                }
            } else {                             // 添加到已选择的数组中
                if (chooseWrongWordList.length === this.chooseWordNum) {
                    if (window.PuTaoA && window.PuTaoA.showTips) {
                        window.PuTaoA.showTips(`你选择的错误选项已超过${this.chooseWordNum}个，先点击取消已选择的吧！`);
                    }
                } else {
                    e.target.style.background = "#FFF2BC";
                    chooseWrongWordList.push(id);
                }
            }

            this.setState({ chooseWrongWordList });
        }
    }

    // 选择
    trueWordsHandler(e) {
        const { chooseRightWordList, selected } = this.state;
        if (!selected) {
            let id = parseInt(e.target.id, 10);
            selectOpsWordsIndex = this.opsWords.indexOf(id) > -1 ? this.opsWords.indexOf(id) : false;

            // 判断选择的单词是否在可选择 list 中
            // 注：每一对选择是有互斥关系的。暂时没有想到比较好的兼容办法，先按可供选择量是两个来做。以 this.opsWords （可供选择的索引值数组）为主，如果当前选择的值在数组中的值是单数，则取消前一个的选中状态，否则取消后一个的选中状态
            if (selectOpsWordsIndex !== false && chooseRightWordList.indexOf(id) === -1) {  //第二个条件是为了防止点击已选择的选项导致done消失：cid=2_12_5&page=26
                // 选择的
                e.target.style.background = "#FFF2BC";
                // 选择的进已选择列表
                chooseRightWordList.push(id);

                // 互斥的
                if (selectOpsWordsIndex % 2 === 0) {
                    mutexOpsWordsIndex = selectOpsWordsIndex + 1;
                } else {
                    mutexOpsWordsIndex = selectOpsWordsIndex - 1;
                }
                document.getElementById(this.opsWords[mutexOpsWordsIndex] + "").style.background = "transparent";
                // 互斥的出已选择列表
                willRemoveIndex = chooseRightWordList.indexOf(this.opsWords[mutexOpsWordsIndex]) > -1 ? chooseRightWordList.indexOf(this.opsWords[mutexOpsWordsIndex]) : false;

                if (willRemoveIndex !== false) {
                    chooseRightWordList.splice(willRemoveIndex, 1);
                }
            }

            this.setState({
                chooseRightWordList
            })

        }

    }

    // 提交答案
    chooseDoneHandler(feedback) {
        const that = this;
        const { childCallback } = this.props;
        const { item, chooseWrongWordList, currStarCount, currSubjectCount, chooseRightWordList } = this.state;
        const judgeFunction = item.detail.judgeFunction;
        const wrongWordIndex = item.detail.wrongWordIndex;
        const timeout = item.detail && item.detail.feedbacks && item.detail.feedbacks.timeout ? item.detail.feedbacks.timeout : null;
        let type = "";
        let info = "";

        // 0.去掉定时
        // 1.显示对错
        // 2.调用判卷
        if (feedback) {
            if (feedback.type) {
                type = feedback.type;
            }
            if (feedback.info) {
                info = feedback.info;
            }
        } else {
            type = timeout ? timeout.type : "";
            info = timeout ? timeout.info : "";
        }

        that.setState({ selected: true });

        if (that.actionType === "ChooseWrongWordsInteraction_") {       // 纠错的处理逻辑
            that.rightOrWrongHandler(chooseWrongWordList, wrongWordIndex, (t, i) => {
                type = t || type;
                info = i || info;
            });
        } else if (that.actionType === "ChooseRightWordsInteraction_") {     // 选择的处理逻辑
            that.rightOrWrongHandler(chooseRightWordList, that.rightWords, (t, i) => {
                type = t || type;
                info = i || info;
            });
        }

        // 调用判卷函数，获得结果
        if (judgeFunction) {
            let returnScore = JSON.parse(window[judgeFunction](
                item.actionID,
                item.detail.resourceID,
                type,
                info,
                item.retryTimes,
                currStarCount,
                currSubjectCount,
            ));

            if (returnScore && returnScore.resultInfo && returnScore.timeline) {
                if (childCallback && typeof childCallback === 'function') {
                    childCallback(returnScore);
                }
            }
        }

        //上报学习报告
        if (that.cid) {
            // Utils.reportRecord(window.startTime, item.actionID, item.actionType, type, 0, item.knowledge);
            if (item.actionID === window.actionID) {
                that.roundNum++;
            } else {
                that.roundNum = 1;
            }
            window.actionID = item.actionID;
            Utils.newReportRecord({
                "putaoid": that.putaoid,
                "token": that.token,
                "cid": that.cid,
                "startTime": window.startTime,
                "actionId": item.actionID,
                "actionType": item.actionType,
                "fbType": type,   //fbType,
                "roundNum": that.roundNum,  //轮数（第几轮回答，默认第一轮：1）
                "score": 0,
                "from": "pc",
                "pageNum": window.curPageToReport || 0,
            }, {
                "knowledge": item.knowledge
            });

            // 给积分
            Utils.giveIntegrals(1, {
                totalTime: timeout ? timeout.time : 60,
                useTime: (new Date().getTime() - that.startWorkTime) / 1000,
                roundNum: that.roundNum,
                fbType: type
            });

            // 勋章上报
            Utils.encourageRecord({
                "putaoid": that.putaoid,
                "token": that.token,
                "cid": that.cid,
                "startTime": window.startTime,
                "actionId": item.actionID,
                "actionType": item.actionType,
                "fbType": type,   //fbType,
                "roundNum": that.roundNum,  //轮数（第几轮回答，默认第一轮：1）
                "score": 0,
                "from": "pc",
                "pageNum": window.curPageToReport || 0,
                "integrals": window.curIntegrals,
            });
        }
    }

    // 判断对错，给错红绿底。
    rightOrWrongHandler(chooseList, rightList, callback) {
        const { item } = this.props;
        let type;
        let info;
        let flag = 0; // flag = 0 未做， flag = "succ" 做对， flag = "fail" 做错

        // 显示选择的对错
        for (let i = 0; i < chooseList.length; i++) {
            if (rightList.indexOf(chooseList[i]) > -1) {
                document.getElementById(chooseList[i] + '').style.background = "#32B96E";
            } else {
                document.getElementById(chooseList[i] + '').style.background = "#FFC3C3";
            }
        }

        // 计算对错结果给判卷
        if (chooseList.length > 0) {
            let tempFlag = chooseList.every((value, index) => (rightList.indexOf(value) > -1) ? true : false)

            if (tempFlag) {
                flag = "succ"
            } else {
                flag = 'fail'
            }

            if (flag && item.detail && item.detail.feedbacks && item.detail.feedbacks[flag]) {
                if (item.detail.feedbacks[flag].info) {
                    info = item.detail.feedbacks[flag].info;
                }
                if (item.detail.feedbacks[flag].type) {
                    type = item.detail.feedbacks[flag].type;
                }
            }
        }

        if (callback && typeof callback === 'function' && (type || info)) {
            callback(type, info)
        }
    }

    render() {
        const that = this;
        const { item, chooseWrongWordList, selected, chooseRightWordList } = this.state;

        return (
            <div>
                {
                    !selected && item.detail.feedbacks && item.detail.feedbacks.timeout && item.detail.feedbacks.timeout.time ?
                        <CountdownTimer feedbacks={item.detail.feedbacks} complateCallback={that.chooseDoneHandler.bind(that)} />
                        : null
                }
                {
                    item.actionType === 'ShowTextArea_' || item.actionType === "ChooseWrongWordsInteraction_" || item.actionType === "ChooseRightWordsInteraction_" ?
                        <div id="choose-sentent" className="sentence" style={{
                            position: 'absolute',
                            top: parseInt(item.detail.pos.y * 100, 10) + "%",
                            left: parseInt(item.detail.pos.x * 100, 10) + "%",
                            width: item.detail.size.width / 2 * window.mainSize.percent + "px",
                            height: item.detail.size.height / 2 * window.mainSize.percent + "px",
                        }}>
                            {
                                that.sentence && Array.isArray(that.sentence) ?
                                    that.sentence.map((value, index) => {
                                        return (<div key={item.actionType + index} id={index}
                                            style={{
                                                cursor: !selected && (item.actionType === "ChooseWrongWordsInteraction_" || item.actionType === "ChooseRightWordsInteraction_") ? "pointer" : null
                                            }}
                                            onClick={e => {
                                                that.chooseWordsHandler(e)
                                            }}
                                        >{value}</div>)
                                    })
                                    : null

                            }
                        </div>
                        : null
                }


                {
                    !selected && ((chooseWrongWordList && chooseWrongWordList.length === that.chooseWordNum) || (chooseRightWordList && chooseRightWordList.length === that.chooseWordNum)) ?
                        <div className="done-btn" onClick={() => {
                            that.chooseDoneHandler()
                        }}>Done</div>
                        : null
                }
            </div>
        )
    }
}

export default ChooseWords;


// WEBPACK FOOTER //
// ./src/components/on/ChooseWords.js